import {Controller} from '@hotwired/stimulus';

// Mêmes saisies que `PickerTimeTransformer` : « 9h30 », « 9 h 30 », « 9:30 », « 0930 », « 9 h » ou « 9 »
const TIME_PATTERN = /^(\d{1,2})(?:\s*[h:]\s*(\d{2})?|(\d{2}))?$/i;

/**
 * Champ Heure d'une date et heure (date-input.md › datetime), posé par `DateTimePickerType` : une saisie lisible
 * est remise au format hh:mm en quittant le champ (« 9h30 » devient « 09:30 »). Une saisie illisible est laissée
 * telle quelle, pour que l'erreur du serveur la montre.
 */
export default class extends Controller {
  normalize() {
    const parts = TIME_PATTERN.exec(this.element.value.trim());

    if (!parts) {
      return;
    }

    const hour = Number(parts[1]);
    const minute = Number(parts[2] ?? parts[3] ?? 0);

    if (hour > 23 || minute > 59) {
      return;
    }

    this.element.value = `${pad(hour)}:${pad(minute)}`;
  }
}

function pad(number) {
  return String(number).padStart(2, '0');
}
